// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectNative_root__17SUp","sSmall":"SelectNative_sSmall__1ZD7e","error":"SelectNative_error__lAIaJ","disabled":"SelectNative_disabled__3koxe"};